// Pure reducer for the persistent per-(patient,month) generate-error map.
// CommonJS so Jest can require it directly (same pattern as assessment-risk.js);
// imported by pages/studio.jsx.
//
// Why this exists: a failed AI generation previously only flashed a ~5s toast,
// so a transient Bedrock error left no lasting trace and the clinician could
// move on believing the draft generated. This map keeps a failure visible on
// the patient's card until the month succeeds, is skipped, or a retry starts.
//
// `key` is `${patientId}:${monthStr}`. `result` is one of:
//   { message }       → record a failure (generic fallback if message empty)
//   { ok: true }      → success, clear the marker
//   { skipped: true } → not actionable, clear the marker
//   { clear: true }   → retry/start, clear the marker

function nextGenError(prev, key, result) {
  const next = { ...(prev || {}) };
  const r = result || {};
  if (r.ok || r.skipped || r.clear) {
    delete next[key];
  } else {
    next[key] = { message: r.message || 'Generate failed' };
  }
  return next;
}

module.exports = { nextGenError };
